exports = module.exports = require("../../../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".column-list[data-v-74ec2ae7] {\n  max-height: 300px;\n  overflow: auto;\n}", ""]);

// exports
